import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import axios from "axios";

// Assure-toi de remplacer "Img" par le bon chemin pour l'image du lit
import Img from '../../assets/images/c4.png';
import api from '../../service/caller';
import { ToastContainer, toast } from 'react-toastify';

const AddRoomForm = ({ onClose }) => {
    const [UserData, setUserData] = useState([]);
    const [formData, setFormData] = useState({
        hospitalId: "", // L'ID de l'hôpital doit être ajouté ici
        type: "General",
        isAirConditioned: false,
        isPrivate: false,
        capacity: 1, // capacité définie par l'utilisateur mais n'affecte pas le nombre de lits
        hasMeals: false,
        pricePerDay: 0,
        beds: [],  // Liste des lits ajoutés manuellement
        selectedBeds: []
    });

    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');
                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);

    // Gérer les changements des champs
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value
        });
    };

    // Gérer la sélection des lits
    const handleBedSelection = (e, bedNumber) => {
        if (e.target.checked) {
            setFormData({
                ...formData,
                selectedBeds: [...formData.selectedBeds, bedNumber]
            });
        } else {
            setFormData({
                ...formData,
                selectedBeds: formData.selectedBeds.filter((bed) => bed !== bedNumber)
            });
        }
    };

    // Fonction pour ajouter un lit
    const handleAddBed = () => {
        const newBedNumber = (formData.beds.length + 1).toString();
        const newBed = {
            bedNumber: newBedNumber,
            isOccupied: false,
            assignedPatient: null
        };
        setFormData({
            ...formData,
            beds: [...formData.beds, newBed]
        });
    };

    // Préparer les données avant l'envoi
    const prepareRoomData = () => {
        let { hospitalId, type, isAirConditioned, isPrivate, capacity, hasMeals, pricePerDay, beds } = formData;

        // Réassigner la valeur de `hospitalId` si nécessaire
        hospitalId = UserData.hospital_id._id;

        // Préparer les lits sous le format attendu par l'API
        const preparedBeds = beds.map(bed => ({
            bedNumber: bed.bedNumber,
            isOccupied: bed.isOccupied,
            assignedPatient: bed.assignedPatient,
        }));

        // Retourner les données prêtes à être envoyées à l'API
        const roomData = {
            hospitalId,
            type,
            isAirConditioned,
            isPrivate,
            capacity,
            foodService: hasMeals,
            pricePerDay,
            beds: preparedBeds
        };

        // Afficher dans la console les données préparées
        console.log("Room Data préparée : ", roomData);

        return roomData;
    };

    // Soumettre le formulaire
    const handleSubmit = async (e) => {
        e.preventDefault();

        const roomData = prepareRoomData(); // Préparer les données avant l'envoi

        console.log("Données à envoyer : ", roomData);

        try {
            const response = await api.post("/api/createrooms", roomData);
            if (response.status === 201) {
                toast.success("Room added successfully!");  // Optionnel: Afficher un message de succès
                onClose();  // Fermer le modal après la soumission réussie
            }
        } catch (error) {
            console.error("Erreur lors de l'ajout de la chambre:", error);
            toast.error("Failed to add room");  // Afficher un message d'erreur
        }
    };


    return (
        <form className="row g-4" onSubmit={handleSubmit}>
            {/* Section : Informations sur la chambre */}
            <div className="col-lg-12">
                <div className="form-field">
                    <label>Type</label>
                    <select
                        className="form-control"
                        name="type"
                        value={formData.type}
                        onChange={handleChange}
                        required
                    >
                        <option value="General">General</option>
                        <option value="Private">Private</option>
                        <option value="ICU">ICU</option>
                    </select>
                </div>
            </div>

            <div className="col-lg-12">
                <div className="form-field">
                    <label>Price Per Day</label>
                    <input
                        type="number"
                        className="form-control"
                        name="pricePerDay"
                        value={formData.pricePerDay}
                        onChange={handleChange}
                        min="0"
                        required
                    />
                </div>
            </div>

            <div className="col-lg-12">
                <div className="form-field">
                    <label>Capacity</label>
                    <input
                        type="number"
                        className="form-control"
                        name="capacity"
                        value={formData.capacity}
                        onChange={handleChange}
                        min="1"
                        required
                    />
                </div>
            </div>

            <div className="col-lg-6">
                <div className="form-field">
                    <label className="mx-2">Is Air Conditioned</label>
                    <input
                        type="checkbox"
                        name="isAirConditioned"
                        checked={formData.isAirConditioned}
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className="col-lg-6">
                <div className="form-field">
                    <label className="mx-2">Is Private</label>
                    <input
                        type="checkbox"
                        name="isPrivate"
                        checked={formData.isPrivate}
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className="col-lg-12">
                <div className="form-field">
                    <label className="mx-2">Has Meals</label>
                    <input
                        type="checkbox"
                        name="hasMeals"
                        checked={formData.hasMeals}
                        onChange={handleChange}
                    />
                </div>
            </div>

            {/* Section : Sélection des lits */}
            <div className="col-lg-12">
                <p><strong>Select Bed(s)</strong></p>
                <div className="d-flex flex-wrap justify-content-between">
                    {formData.beds.map((bed, index) => (
                        <div key={index} className="mb-4" style={{ width: '48%' }}>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`bed-${bed.bedNumber}`}
                                    onChange={(e) => handleBedSelection(e, bed.bedNumber)}
                                    checked={formData.selectedBeds.includes(bed.bedNumber)}
                                />
                                <label className="form-check-label" htmlFor={`bed-${bed.bedNumber}`}>
                                    <strong>
                                        <img
                                            src={Img}
                                            alt={`Bed ${bed.bedNumber}`}
                                            className="me-2"
                                            style={{ width: '20%' }}
                                        />
                                        <span>B - {bed.bedNumber}</span>
                                    </strong>
                                </label>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Ajouter un lit */}
            <div className="col-lg-12">
                <Button
                    variant="secondary"
                    type="button"
                    onClick={handleAddBed}
                    style={{ width: '100%' }}
                >
                    Add Bed
                </Button>
            </div>

            {/* Soumettre le formulaire */}
            <div className="col-lg-12 mt-3">
                <Button variant="primary" type="submit" style={{ width: '100%' }}>
                    Save Room
                </Button>
            </div>
        </form>
    );
};

export default AddRoomForm;
